import { MedicalType, MedicalTypeIds } from ".";

export const medicalTypes: MedicalType[] = [
    {
        id: MedicalTypeIds.Skin,
        name: "Skin Questionnaire",
        category: "HealthSurveillance",
        isObsolete: true
    },
    {
        id: MedicalTypeIds.SkinFaceToFace,
        name: "Skin Face to Face Appointment",
        category: "HealthSurveillance",
        isObsolete: true
    },
    {
        id: MedicalTypeIds.Audiometry,
        name: "Audiometry",
        category: "HealthSurveillance"
    },
    {
        id: MedicalTypeIds.RespiratorySensitiser,
        name: "Respiratory Sensitiser - Level 2",
        category: "HealthSurveillance"
    },
    {
        id: MedicalTypeIds.RespiratorySensitiserFaceToFaceLevel1,
        name: "Respiratory Sensitiser Face to Face - Level 1",
        category: "HealthSurveillance"
    },
    {
        id: MedicalTypeIds.RespiratorySensitiserQuestionnaireLevel1,
        name: "Respiratory Sensitiser Questionnaire - Level 1",
        category: "HealthSurveillance"
    },
    {
        id: MedicalTypeIds.HAVS,
        name: "HAVS Questionnaire",
        category: "HealthSurveillance"
    },
    {
        id: MedicalTypeIds.HAVSFaceToFace,
        name: "HAVS Face to Face",
        category: "HealthSurveillance"
    },
    {
        id: MedicalTypeIds.IonisingRadiation,
        name: "Ionising Radiation Questionnaire",
        category: "HealthSurveillance"
    },
    {
        id: MedicalTypeIds.IonisingRadiationFaceToFace,
        name: "Ionising Radiation Face to Face",
        category: "HealthSurveillance"
    },
    {
        id: MedicalTypeIds.BiologicalMonitoring,
        name: "Biological Monitoring",
        category: "HealthSurveillance"
    },
    {
        id: MedicalTypeIds.OtherSurveillance,
        name: "Other Surveillance",
        category: "HealthSurveillance"
    },
    {
        id: MedicalTypeIds.LAAWorker,
        name: "LAA Worker",
        category: "HealthSurveillance"
    },

    {
        id: MedicalTypeIds.SafetyCriticalWorker,
        name: "Safety Critical Worker",
        category: "FitForWork"
    },
    {
        id: MedicalTypeIds.GroupOneDriving,
        name: "Group 1 Driving",
        category: "FitForWork"
    },
    {
        id: MedicalTypeIds.GroupTwoDriving,
        name: "Group 2 Driving",
        category: "FitForWork"
    },
    {
        id: MedicalTypeIds.WorkAtHeight,
        name: "Work at height",
        category: "FitForWork"
    },
    {
        id: MedicalTypeIds.WorkingConfinedSpaces,
        name: "Working in Confined Spaces",
        category: "FitForWork"
    },
    {
        id: MedicalTypeIds.WearingRPE,
        name: "Wearing RPE (dust masks / respirators)",
        category: "FitForWork"
    },
    {
        id: MedicalTypeIds.WearingBreathingApparatus,
        name: "Wearing Breathing Apparatus",
        category: "FitForWork"
    },
    {
        id: MedicalTypeIds.WorkingThermalEnvironment,
        name: "Working in a thermal Environment / Cold Storage",
        category: "FitForWork"
    },
    {
        id: MedicalTypeIds.NightWorker,
        name: "Night worker",
        category: "FitForWork"
    },
    {
        id: MedicalTypeIds.LoneWorker,
        name: "Lone Worker",
        category: "FitForWork"
    },
    {
        id: MedicalTypeIds.FoodHandlerQuestionsOnly,
        name: "Food Handler Questions Only",
        category: "FitForWork"
    },
    {
        id: MedicalTypeIds.DSE,
        name: "Vision Screening",
        category: "FitForWork"
    },
    {
        id: MedicalTypeIds.Offshore,
        name: "Offshore",
        category: "FitForWork"
    },
    {
        id: MedicalTypeIds.Airside,
        name: "Airside",
        category: "FitForWork"
    },
    {
        id: MedicalTypeIds.OtherFitnessToWork,
        name: "Other Fitness to Work",
        category: "FitForWork"
    },
    {
        id: MedicalTypeIds.ManualHandlingMSKQuestionnaire,
        name: "Manual Handling / MSK Questionnaire",
        category: "FitForWork"
    },
    {
        id: MedicalTypeIds.ManualHandlingMSKFaceToFaceAppointment,
        name: "Manual Handling / MSK Face to Face Appointment",
        category: "FitForWork"
    },
    {
        id: MedicalTypeIds.AmzPitPupMedical,
        name: "AMZ PIT/PUP Medical",
        category: "FitForWork"
    },
    {
        id: MedicalTypeIds.AmzPitPupHealthDeclaration,
        name: "AMZ PIT/PUP Health Declaration",
        category: "FitForWork"
    },
    {
        id: MedicalTypeIds.FieldForce,
        name: "Field Force Medical",
        category: "FitForWork"
    },
    {
        id: MedicalTypeIds.SkinLevel1,
        name: "Skin Questionnaire - Level 1",
        category: "HealthSurveillance"
    },
    {
        id: MedicalTypeIds.SkinFaceToFaceLevel1,
        name: "Skin Face to Face Appointment - Level 1",
        category: "HealthSurveillance"
    },
    {
        id: MedicalTypeIds.SkinAssessmentLevel2,
        name: "Skin Assessment - Level 2",
        category: "HealthSurveillance"
    }
];
